var React = require('react');

function RectangleLandscape (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M464 64H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zm-16 304a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V144a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 368V144a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16v224a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16z","className":"fa-primary","key":2})]);
}

RectangleLandscape.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = RectangleLandscape;

RectangleLandscape.default = RectangleLandscape;
